import ServicesApi from './ServicesApi';

export default class MemoApi {
  static servicePrefix = 'memoservice/';

  static async getCounterpartyMemos(counterpartyCode) {
    const headers = await ServicesApi.getHeaders();

    var url = MemoApi.servicePrefix + 'getCounterpartyMemos?counterpartyCode=' +
      encodeURIComponent(counterpartyCode);

    const memosResponse = await fetch(
      url, {
      method: 'GET',
      headers: headers
    });

    return await memosResponse.json();
  }

  static async postCounterpartyMemos(counterpartyMemoDtos) {
    const headers = await ServicesApi.getHeaders();

    var memosResponse = await fetch(
      MemoApi.servicePrefix + 'createCounterpartyMemos', {
      method: 'POST',
      headers: headers,
        body: JSON.stringify(counterpartyMemoDtos)
    });

    return await memosResponse.json();
  }

  static async putCounterpartyMemos(counterpartyMemoDtos) {
    const headers = await ServicesApi.getHeaders();

    var memosResponse = await fetch(
      MemoApi.servicePrefix + 'updateCounterpartyMemos', {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(counterpartyMemoDtos)
    });

    return await memosResponse.json();
  }

  static async deleteCounterpartyMemo(memoGuid) {
    const headers = await ServicesApi.getHeaders();

    var url = MemoApi.servicePrefix + 'deleteCounterpartyMemo?memoGuid=' +
      encodeURIComponent(memoGuid);

    var memosResponse =  await fetch(
      url, {
      method: 'DELETE',
      headers: headers,
    });

    return await memosResponse.json();
  }
}